<template>
  <table class="m-table TutorForm">
    <!-- {{user}} -->
    <!-- {{office_channels}} -->
    <!-- {{orderedOffice_channels}} -->
    <!-- {{filteredOffice_channels}} -->
    <!-- {{mapOffice_channels}} -->
    <tbody>
      <tr>
        <th colspan="2" class="req">状態</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="state_0">未選択</label>
            <input type="radio" name="state" required id="state_0" value="0" v-model="tutor.state" @keypress.self.prevent.13>
            <label for="state_1">指導可能</label>
            <input type="radio" name="state" id="state_1" value="1" v-model="tutor.state" @keypress.self.prevent.13>
            <label for="state_2">指導不可</label>
            <input type="radio" name="state" id="state_2" value="2" v-model="tutor.state" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2" class="req">登録日</th>
        <td colspan="4"><input type="text" required maxlength="10" minlength="10" v-model="tutor.registration_date" placeholder="登録日" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">名前</th>
        <td colspan="5"><input type='text' v-model="tutor.f_name" placeholder="姓" @keypress.self.prevent.13></td>
        <td colspan="5"><input type='text' v-model="tutor.l_name" placeholder="名" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">かな</th>
        <td colspan="5"><input type='text' required v-model="tutor.f_name_kana" placeholder="せい" @keypress.self.prevent.13></td>
        <td colspan="5"><input type='text' required v-model="tutor.l_name_kana" placeholder="めい" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">性別</th>
        <td colspan="10" class="checkbox">
          <div>
            <label for="gender_0">未選択</label>
            <input type="radio" id="gender_0" value="0" v-model="tutor.gender" @keypress.self.prevent.13>
            <label for="gender_1">男</label>
            <input type="radio" id="gender_1" value="1" v-model="tutor.gender" @keypress.self.prevent.13>
            <label for="gender_2">女</label>
            <input type="radio" id="gender_2" value="2" v-model="tutor.gender" @keypress.self.prevent.13>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="2" class="req">生年月日</th>
        <td colspan="4"><input type="text" required maxlength="10" minlength="10" v-model="tutor.birthday" placeholder="生年月日" @keypress.self.prevent.13></td>
        <th colspan="2">年齢</th>
        <td colspan="4"><div class="calc">{{calcAge}}</div></td>
      </tr>
      <tr>
        <th colspan="2">郵便番号</th>
        <td colspan="4"><input type='text' v-model="tutor.zip" @keyup="getYubin" placeholder="0000000" @keypress.self.prevent.13></td>
        <th colspan="2" class="req">都道府県</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.pref" :options="prefs" label="name" :searchable="true" :show-labels="false" placeholder="都道府県"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2" class="req">住所</th>
        <td colspan="5"><input type='text' required v-model="tutor.address1" placeholder="市区町村・番地" @keypress.self.prevent.13></td>
        <td colspan="5"><input type='text' v-model="tutor.address2" placeholder="建物名・部屋番号" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">携帯TEL</th>
        <td colspan="4"><input type='text' required maxlength="11" minlength="10" v-model="tutor.tel1" placeholder="携帯TEL" @keypress.self.prevent.13></td>
        <th colspan="2">固定TEL</th>
        <td colspan="4"><input type='text' maxlength="11" minlength="10" v-model="tutor.tel2" placeholder="固定TEL" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">MAIL1</th>
        <td colspan="4"><input type='text' v-model="tutor.mail1" placeholder="MAIL1" @keypress.self.prevent.13></td>
        <th colspan="2">MAIL2</th>
        <td colspan="4"><input type='text' v-model="tutor.mail2" placeholder="MAIL2" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">実家郵便番号</th>
        <td colspan="4"><input type='text' v-model="tutor.home_zip" @keyup="getYubin2" placeholder="0000000 (実家)" @keypress.self.prevent.13></td>
        <th colspan="2">都道府県</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.home_pref" :options="prefs" label="name" :searchable="true" :show-labels="false" placeholder="都道府県"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">実家住所</th>
        <td colspan="5"><input type='text' v-model="tutor.home_address1" placeholder="市区町村・番地 (実家)" @keypress.self.prevent.13></td>
        <td colspan="5"><input type='text' v-model="tutor.home_address2" placeholder="建物名・部屋番号 (実家)" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">実家TEL</th>
        <td colspan="10"><input type='text' maxlength="11" minlength="10" v-model="tutor.home_tel" placeholder="実家TEL" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">学校名</th>
        <td colspan="4"><input type='text' v-model="tutor.school_name" placeholder="東北 (大学/専門無)" @keypress.self.prevent.13></td>
        <th colspan="2" class="req">区分</th>
        <td colspan="4"><multiselect v-model="watch.school_stage" :options="school_stage" label="name" :searchable="false" :show-labels="false" placeholder="区分"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">学部</th>
        <td colspan="4"><input type='text' v-model="tutor.department" placeholder="学部" @keypress.self.prevent.13></td>
        <th colspan="2">学年</th>
        <td colspan="2"><div class="calc">{{calcGrade}}</div></td>
        <td colspan="2"><input type='number' v-model="tutor.grade_flag" placeholder="留年・浪人" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">文系/理系</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="department_type_0">未選択</label>
            <input type="radio" id="department_type_0" value="0" v-model="tutor.department_type" @keypress.self.prevent.13>
            <label for="department_type_1">文系</label>
            <input type="radio" id="department_type_1" value="1" v-model="tutor.department_type" @keypress.self.prevent.13>
            <label for="department_type_2">理系</label>
            <input type="radio" id="department_type_2" value="2" v-model="tutor.department_type" @keypress.self.prevent.13>
            <label for="department_type_3">他</label>
            <input type="radio" id="department_type_3" value="3" v-model="tutor.department_type" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">サークル</th>
        <td colspan="4"><input type='text' v-model="tutor.club" placeholder="サークル" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">高校部活</th>
        <td colspan="4"><input type='text' v-model="tutor.high_school_club" placeholder="高校部活" @keypress.self.prevent.13></td>
        <th colspan="2">出身高校</th>
        <td colspan="4"><input type='text' v-model="tutor.high_school_name" placeholder="出身高校" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">移動手段</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="car">車</label>
            <input type="checkbox" id="car" v-model="watch.transportation_car" @keypress.self.prevent.13>
            <label for="bike">バイク</label>
            <input type="checkbox" id="bike" v-model="watch.transportation_bike" @keypress.self.prevent.13>
            <label for="scooters">原付</label>
            <input type="checkbox" id="scooters" v-model="watch.transportation_scooters" @keypress.self.prevent.13>
            <label for="bicycle">自転車</label>
            <input type="checkbox" id="bicycle" v-model="watch.transportation_bicycle" @keypress.self.prevent.13>
            <label for="train">電車</label>
            <input type="checkbox" id="train" v-model="watch.transportation_train" @keypress.self.prevent.13>
            <label for="none">無し</label>
            <input type="checkbox" id="none" v-model="watch.transportation_none" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">最寄駅</th>
        <td colspan="10"><input type='text' v-model="tutor.nearest_station" placeholder="仙台駅" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">受験経験</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="exam_s">小学</label>
            <input type="checkbox" id="exam_s" v-model="watch.exam_s" @keypress.self.prevent.13>
            <label for="exam_c">中学</label>
            <input type="checkbox" id="exam_c" v-model="watch.exam_c" @keypress.self.prevent.13>
            <label for="exam_k">高校</label>
            <input type="checkbox" id="exam_k" v-model="watch.exam_k" @keypress.self.prevent.13>
            <label for="exam_d">大学</label>
            <input type="checkbox" id="exam_d" v-model="watch.exam_d" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">家庭教師・塾講師経験</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="experience_tutor">家庭教師</label>
            <input type="checkbox" id="experience_tutor" v-model="watch.experience_tutor" @keypress.self.prevent.13>
            <label for="experience_cram">塾講師</label>
            <input type="checkbox" id="experience_cram" v-model="watch.experience_cram" @keypress.self.prevent.13>
            <label for="experience_none">無し</label>
            <input type="checkbox" id="experience_none" v-model="watch.experience_none" @keypress.self.prevent.13>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="2">家庭教師備考</th>
        <td colspan="4"><input type='text' v-model="tutor.experience_tutor_note" placeholder="家庭教師備考" @keypress.self.prevent.13></td>
        <th colspan="2">塾講師備考</th>
        <td colspan="4"><input type='text' v-model="tutor.experience_cram_note" placeholder="塾講師備考" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">登録媒体</th>
        <td colspan="4">
          <multiselect @select="select" v-model="watch.medium" :options="mapOffice_channels" label="mapChannel_id" :searchable="false" :show-labels="false" placeholder="媒体"></multiselect>
        </td>
        <th colspan="2">備考(登録媒体)</th>
        <td colspan="4"><input type='text' v-model="tutor.medium_note" placeholder="登録媒体備考" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">HP/パンフ掲載</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="published_0">未選択</label>
            <input type="radio" id="published_0" value="0" v-model="tutor.published" @keypress.self.prevent.13>
            <label for="published_1">OK</label>
            <input type="radio" id="published_1" value="1" v-model="tutor.published" @keypress.self.prevent.13>
            <label for="published_2">NG</label>
            <input type="radio" id="published_2" value="2" v-model="tutor.published" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2" class="req">情報発信</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="information_0">未選択</label>
            <input type="radio" name="information" required id="information_0" value="0" v-model="tutor.information" @keypress.self.prevent.13>
            <label for="information_1">OK</label>
            <input type="radio" name="information" id="information_1" value="1" v-model="tutor.information" @keypress.self.prevent.13>
            <label for="information_2">NG</label>
            <input type="radio" name="information" id="information_2" value="2" v-model="tutor.information" @keypress.self.prevent.13>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="2">印象ランク</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="impression_0">未選択</label>
            <input type="radio" id="impression_0" value="0" v-model="tutor.impression" @keypress.self.prevent.13>
            <label for="impression_1">AA</label>
            <input type="radio" id="impression_1" value="1" v-model="tutor.impression" @keypress.self.prevent.13>
            <label for="impression_2">A</label>
            <input type="radio" id="impression_2" value="2" v-model="tutor.impression" @keypress.self.prevent.13>
            <label for="impression_3">B</label>
            <input type="radio" id="impression_3" value="3" v-model="tutor.impression" @keypress.self.prevent.13>
            <label for="impression_4">C</label>
            <input type="radio" id="impression_4" value="4" v-model="tutor.impression" @keypress.self.prevent.13>
            <label for="impression_5">Z</label>
            <input type="radio" id="impression_5" value="5" v-model="tutor.impression" @keypress.self.prevent.13>
            <label for="impression_6">紹介不可</label>
            <input type="radio" id="impression_6" value="6" v-model="tutor.impression" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">印象ランク備考</th>
        <td colspan="4"><input type='text' v-model="tutor.impression_note" placeholder="印象ランク備考" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">研修</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="training">研修</label>
            <input type="checkbox" id="training" v-model="watch.training" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">研修備考</th>
        <td colspan="4"><input type='text' v-model="tutor.training_note" placeholder="研修備考" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">SSK</th>
        <td colspan="10" class="checkbox">
          <div>
            <label for="ssk">SSK</label>
            <input type="checkbox" id="ssk" v-model="watch.ssk" @keypress.self.prevent.13>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="2">備考</th>
        <td colspan="10"><textarea type='text' v-model="tutor.note" placeholder="備考"></textarea></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment'
let jsonp = require('jsonp')

let _ = window._
export default {
  props: {
    tutor: Object,
    watch: Object
  },
  data () {
    return {
      registration_date: moment().format('YYYY/MM/DD')
    }
  },
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },
  computed: {
    school_stage () {
      return this.$store.getters['tutors/school_stage']
    },

    user () {
      return this.$store.getters.user
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    },

    channels () {
      return this.$store.getters.channels
    },

    office_channels () {
      return this.$store.getters.office_channels
    },

    orderedOffice_channels () {
      return _.orderBy(this.office_channels, 'id')
    },

    filteredOffice_channels () {
      const office_id = this.user.office_id
      return this.orderedOffice_channels.filter(office_channel => {
        return office_channel.state === 1 && office_channel.office_id === office_id
      })
    },

    mapOffice_channels () {
      return this.filteredOffice_channels.map(office_channel => {
        office_channel.mapChannel_id = this.calcArry(office_channel.channel_id, 'channels')
        return office_channel
      })
    },

    calcAge () {
      let x = Date.parse(this.tutor.birthday) // 変換(ミリ秒が返される)
      let date = new Date(x) // ミリ秒をnew Dateに渡す
      let ageDifMs = Date.now() - date // 差分(ミリ秒)
      let ageDate = new Date(ageDifMs) // ミリ秒をnew Dateに渡す
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade () {
      let self = this

      let x = Date.parse(self.tutor.birthday) // 変換(ミリ秒が返される)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }

      let ageNumber
      for (let i = 0; i < 100; i++) {
        if (birthdate >= new Date(year - i, 3, 2) && birthdate <= new Date(year - (i - 1), 3, 1, 23, 59)) {
          ageNumber = i
        }
      }

      let gradeNumber = ageNumber + Number(self.tutor.grade_flag)

      let grade

      if (gradeNumber === 4) {
        grade = '幼稚園年少'
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'
      } else if (gradeNumber === 7) {
        grade = '小学1年生'
      } else if (gradeNumber === 8) {
        grade = '小学2年生'
      } else if (gradeNumber === 9) {
        grade = '小学3年生'
      } else if (gradeNumber === 10) {
        grade = '小学4年生'
      } else if (gradeNumber === 11) {
        grade = '小学5年生'
      } else if (gradeNumber === 12) {
        grade = '小学6年生'
      } else if (gradeNumber === 13) {
        grade = '中学1年生'
      } else if (gradeNumber === 14) {
        grade = '中学2年生'
      } else if (gradeNumber === 15) {
        grade = '中学3年生'
      } else if (gradeNumber === 16) {
        grade = '高校1年生'
      } else if (gradeNumber === 17) {
        grade = '高校2年生'
      } else if (gradeNumber === 18) {
        grade = '高校3年生'
      } else if (gradeNumber === 19) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門1年生'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門1年生'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大1年生'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専4年生'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門1年生'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学1年生'
        }
      } else if (gradeNumber === 20) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年生'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門2年生'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年生'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専5年生'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門2年生'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学2年生'
        }
      } else if (gradeNumber === 21) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年生'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学3年生'
        }
      } else if (gradeNumber === 22) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学4年生'
        }
      } else if (gradeNumber === 23) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学M1'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学5年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学卒業'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学M1'
        }
      } else if (gradeNumber === 24) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学M2'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学6年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学卒業'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学M2'
        }
      } else if (gradeNumber === 25) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学院卒業'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学6年制卒業'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学卒業'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学D1'
        }
      } else if (gradeNumber === 26) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学院卒業'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学6年制卒業'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学卒業'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学D2'
        }
      } else if (gradeNumber > 26) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学院卒業'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学6年制卒業'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学卒業'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '博士課程卒業'
        }
      } else {
        grade = ''
      }
      return grade
    }
  },
  methods: {
    calcArry (val, text) {
      // console.log(this[text])
      if (this[text].length > 0) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    getYubin (e) {
      let that = this
      // console.log(e)
      const value = e.target.value
      if (value.length > 5 && that.tutor.address1 === '') {
        jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
          if (err) {
            // error
            console.error(err.message)
          } else {
            // success
            console.log(data)
            if (data.results[0].address1 === '北海道') {
              that.watch.pref = { name: '1. 北海道', id: 1 }
            } else if (data.results[0].address1 === '青森県') {
              that.watch.pref = { name: '2. 青森県', id: 2 }
            } else if (data.results[0].address1 === '秋田県') {
              that.watch.pref = { name: '3. 秋田県', id: 3 }
            } else if (data.results[0].address1 === '岩手県') {
              that.watch.pref = { name: '4. 岩手県', id: 4 }
            } else if (data.results[0].address1 === '山形県') {
              that.watch.pref = { name: '5. 山形県', id: 5 }
            } else if (data.results[0].address1 === '宮城県') {
              that.watch.pref = { name: '6. 宮城県', id: 6 }
            } else if (data.results[0].address1 === '福島県') {
              that.watch.pref = { name: '7. 福島県', id: 7 }
            } else if (data.results[0].address1 === '栃木県') {
              that.watch.pref = { name: '8. 栃木県', id: 8 }
            } else if (data.results[0].address1 === '山梨県') {
              that.watch.pref = { name: '9. 山梨県', id: 9 }
            } else if (data.results[0].address1 === '群馬県') {
              that.watch.pref = { name: '10. 群馬県', id: 10 }
            } else if (data.results[0].address1 === '茨城県') {
              that.watch.pref = { name: '11. 茨城県', id: 11 }
            } else if (data.results[0].address1 === '千葉県') {
              that.watch.pref = { name: '12. 千葉県', id: 12 }
            } else if (data.results[0].address1 === '埼玉県') {
              that.watch.pref = { name: '13. 埼玉県', id: 13 }
            } else if (data.results[0].address1 === '東京都') {
              that.watch.pref = { name: '14. 東京都', id: 14 }
            } else if (data.results[0].address1 === '神奈川県') {
              that.watch.pref = { name: '15. 神奈川県', id: 15 }
            } else if (data.results[0].address1 === '静岡県') {
              that.watch.pref = { name: '16. 静岡県', id: 16 }
            } else if (data.results[0].address1 === '長野県') {
              that.watch.pref = { name: '17. 長野県', id: 17 }
            } else if (data.results[0].address1 === '愛知県') {
              that.watch.pref = { name: '18. 愛知県', id: 18 }
            } else if (data.results[0].address1 === '岐阜県') {
              that.watch.pref = { name: '19. 岐阜県', id: 19 }
            } else if (data.results[0].address1 === '新潟県') {
              that.watch.pref = { name: '20. 新潟県', id: 20 }
            } else if (data.results[0].address1 === '富山県') {
              that.watch.pref = { name: '21. 富山県', id: 21 }
            } else if (data.results[0].address1 === '石川県') {
              that.watch.pref = { name: '22. 石川県', id: 22 }
            } else if (data.results[0].address1 === '福井県') {
              that.watch.pref = { name: '23. 福井県', id: 23 }
            } else if (data.results[0].address1 === '滋賀県') {
              that.watch.pref = { name: '24. 滋賀県', id: 24 }
            } else if (data.results[0].address1 === '京都府') {
              that.watch.pref = { name: '25. 京都府', id: 25 }
            } else if (data.results[0].address1 === '三重県') {
              that.watch.pref = { name: '26. 三重県', id: 26 }
            } else if (data.results[0].address1 === '和歌山県') {
              that.watch.pref = { name: '27. 和歌山県', id: 27 }
            } else if (data.results[0].address1 === '奈良県') {
              that.watch.pref = { name: '28. 奈良県', id: 28 }
            } else if (data.results[0].address1 === '大阪府') {
              that.watch.pref = { name: '29. 大阪府', id: 29 }
            } else if (data.results[0].address1 === '兵庫県') {
              that.watch.pref = { name: '30. 兵庫県', id: 30 }
            } else if (data.results[0].address1 === '鳥取県') {
              that.watch.pref = { name: '31. 鳥取県', id: 31 }
            } else if (data.results[0].address1 === '島根県') {
              that.watch.pref = { name: '32. 島根県', id: 32 }
            } else if (data.results[0].address1 === '岡山県') {
              that.watch.pref = { name: '33. 岡山県', id: 33 }
            } else if (data.results[0].address1 === '広島県') {
              that.watch.pref = { name: '34. 広島県', id: 34 }
            } else if (data.results[0].address1 === '山口県') {
              that.watch.pref = { name: '35. 山口県', id: 35 }
            } else if (data.results[0].address1 === '高知県') {
              that.watch.pref = { name: '36. 高知県', id: 36 }
            } else if (data.results[0].address1 === '徳島県') {
              that.watch.pref = { name: '37. 徳島県', id: 37 }
            } else if (data.results[0].address1 === '香川県') {
              that.watch.pref = { name: '38. 香川県', id: 38 }
            } else if (data.results[0].address1 === '愛媛県') {
              that.watch.pref = { name: '39. 愛媛県', id: 39 }
            } else if (data.results[0].address1 === '福岡県') {
              that.watch.pref = { name: '40. 福岡県', id: 40 }
            } else if (data.results[0].address1 === '佐賀県') {
              that.watch.pref = { name: '41. 佐賀県', id: 41 }
            } else if (data.results[0].address1 === '長崎県') {
              that.watch.pref = { name: '42. 長崎県', id: 42 }
            } else if (data.results[0].address1 === '熊本県') {
              that.watch.pref = { name: '43. 熊本県', id: 43 }
            } else if (data.results[0].address1 === '宮崎県') {
              that.watch.pref = { name: '44. 宮崎県', id: 44 }
            } else if (data.results[0].address1 === '大分県') {
              that.watch.pref = { name: '45. 大分県', id: 45 }
            } else if (data.results[0].address1 === '鹿児島県') {
              that.watch.pref = { name: '46. 鹿児島県', id: 46 }
            } else if (data.results[0].address1 === '沖縄県') {
              that.watch.pref = { name: '47. 沖縄県', id: 47 }
            }
            that.tutor.address1 = data.results[0].address2 + data.results[0].address3
          }
        })
      }
    },
    getYubin2 (e) {
      let that = this
      // console.log(e)
      const value = e.target.value
      if (value.length > 5 && that.tutor.home_address1 === '') {
        jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
          if (err) {
            // error
            console.error(err.message)
          } else {
            // success
            console.log(data)
            if (data.results[0].address1 === '北海道') {
              that.watch.home_pref = { name: '1. 北海道', id: 1 }
            } else if (data.results[0].address1 === '青森県') {
              that.watch.home_pref = { name: '2. 青森県', id: 2 }
            } else if (data.results[0].address1 === '秋田県') {
              that.watch.home_pref = { name: '3. 秋田県', id: 3 }
            } else if (data.results[0].address1 === '岩手県') {
              that.watch.home_pref = { name: '4. 岩手県', id: 4 }
            } else if (data.results[0].address1 === '山形県') {
              that.watch.home_pref = { name: '5. 山形県', id: 5 }
            } else if (data.results[0].address1 === '宮城県') {
              that.watch.home_pref = { name: '6. 宮城県', id: 6 }
            } else if (data.results[0].address1 === '福島県') {
              that.watch.home_pref = { name: '7. 福島県', id: 7 }
            } else if (data.results[0].address1 === '栃木県') {
              that.watch.home_pref = { name: '8. 栃木県', id: 8 }
            } else if (data.results[0].address1 === '山梨県') {
              that.watch.home_pref = { name: '9. 山梨県', id: 9 }
            } else if (data.results[0].address1 === '群馬県') {
              that.watch.home_pref = { name: '10. 群馬県', id: 10 }
            } else if (data.results[0].address1 === '茨城県') {
              that.watch.home_pref = { name: '11. 茨城県', id: 11 }
            } else if (data.results[0].address1 === '千葉県') {
              that.watch.home_pref = { name: '12. 千葉県', id: 12 }
            } else if (data.results[0].address1 === '埼玉県') {
              that.watch.home_pref = { name: '13. 埼玉県', id: 13 }
            } else if (data.results[0].address1 === '東京都') {
              that.watch.home_pref = { name: '14. 東京都', id: 14 }
            } else if (data.results[0].address1 === '神奈川県') {
              that.watch.home_pref = { name: '15. 神奈川県', id: 15 }
            } else if (data.results[0].address1 === '静岡県') {
              that.watch.home_pref = { name: '16. 静岡県', id: 16 }
            } else if (data.results[0].address1 === '長野県') {
              that.watch.home_pref = { name: '17. 長野県', id: 17 }
            } else if (data.results[0].address1 === '愛知県') {
              that.watch.home_pref = { name: '18. 愛知県', id: 18 }
            } else if (data.results[0].address1 === '岐阜県') {
              that.watch.home_pref = { name: '19. 岐阜県', id: 19 }
            } else if (data.results[0].address1 === '新潟県') {
              that.watch.home_pref = { name: '20. 新潟県', id: 20 }
            } else if (data.results[0].address1 === '富山県') {
              that.watch.home_pref = { name: '21. 富山県', id: 21 }
            } else if (data.results[0].address1 === '石川県') {
              that.watch.home_pref = { name: '22. 石川県', id: 22 }
            } else if (data.results[0].address1 === '福井県') {
              that.watch.home_pref = { name: '23. 福井県', id: 23 }
            } else if (data.results[0].address1 === '滋賀県') {
              that.watch.home_pref = { name: '24. 滋賀県', id: 24 }
            } else if (data.results[0].address1 === '京都府') {
              that.watch.home_pref = { name: '25. 京都府', id: 25 }
            } else if (data.results[0].address1 === '三重県') {
              that.watch.home_pref = { name: '26. 三重県', id: 26 }
            } else if (data.results[0].address1 === '和歌山県') {
              that.watch.home_pref = { name: '27. 和歌山県', id: 27 }
            } else if (data.results[0].address1 === '奈良県') {
              that.watch.home_pref = { name: '28. 奈良県', id: 28 }
            } else if (data.results[0].address1 === '大阪府') {
              that.watch.home_pref = { name: '29. 大阪府', id: 29 }
            } else if (data.results[0].address1 === '兵庫県') {
              that.watch.home_pref = { name: '30. 兵庫県', id: 30 }
            } else if (data.results[0].address1 === '鳥取県') {
              that.watch.home_pref = { name: '31. 鳥取県', id: 31 }
            } else if (data.results[0].address1 === '島根県') {
              that.watch.home_pref = { name: '32. 島根県', id: 32 }
            } else if (data.results[0].address1 === '岡山県') {
              that.watch.home_pref = { name: '33. 岡山県', id: 33 }
            } else if (data.results[0].address1 === '広島県') {
              that.watch.home_pref = { name: '34. 広島県', id: 34 }
            } else if (data.results[0].address1 === '山口県') {
              that.watch.home_pref = { name: '35. 山口県', id: 35 }
            } else if (data.results[0].address1 === '高知県') {
              that.watch.home_pref = { name: '36. 高知県', id: 36 }
            } else if (data.results[0].address1 === '徳島県') {
              that.watch.home_pref = { name: '37. 徳島県', id: 37 }
            } else if (data.results[0].address1 === '香川県') {
              that.watch.home_pref = { name: '38. 香川県', id: 38 }
            } else if (data.results[0].address1 === '愛媛県') {
              that.watch.home_pref = { name: '39. 愛媛県', id: 39 }
            } else if (data.results[0].address1 === '福岡県') {
              that.watch.home_pref = { name: '40. 福岡県', id: 40 }
            } else if (data.results[0].address1 === '佐賀県') {
              that.watch.home_pref = { name: '41. 佐賀県', id: 41 }
            } else if (data.results[0].address1 === '長崎県') {
              that.watch.home_pref = { name: '42. 長崎県', id: 42 }
            } else if (data.results[0].address1 === '熊本県') {
              that.watch.home_pref = { name: '43. 熊本県', id: 43 }
            } else if (data.results[0].address1 === '宮崎県') {
              that.watch.home_pref = { name: '44. 宮崎県', id: 44 }
            } else if (data.results[0].address1 === '大分県') {
              that.watch.home_pref = { name: '45. 大分県', id: 45 }
            } else if (data.results[0].address1 === '鹿児島県') {
              that.watch.home_pref = { name: '46. 鹿児島県', id: 46 }
            } else if (data.results[0].address1 === '沖縄県') {
              that.watch.home_pref = { name: '47. 沖縄県', id: 47 }
            }
            that.tutor.home_address1 = data.results[0].address2 + data.results[0].address3
          }
        })
      }
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss' scoped>
.req {
  background: #41b883;
}
table {
  border-spacing: 0;
  width: 100%;
  border-top: solid 1px #ddd;
  tr {
    th {
      background: #37474f;
      color: #fbfbfb;
      padding: .5rem;
      font-weight: normal;
      font-size: .85rem;
    }
    td {
      border-bottom: solid 1px #ddd;
      border-right: solid 1px #ddd;
      input, textarea, .calc {
        outline: 0;
        border: none;
        width: 100%;
        padding: .5rem;
        font-size: .85rem;
        &:focus {
          background: #cdeeff;
        }
      }
      textarea {
        height: 150px;
        &:focus {
          background: #cdeeff;
        }
      }
    }
  }
}
.checkbox {
  font-size: .85rem;
  color: #333;
  div {
    display: flex;
    label {
      padding-top: 9px;
      padding-left: 5px;
    }
    input {
      height: 29px;
      width: 20px;
    }
  }
}
</style>

<style lang="scss">
.TutorForm {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: .85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: .85rem;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: .5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// TutorForm.vue?6819e8b6